import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDesignTokens } from "../../../theme/useDesignTokens";
import Button from "../Button/Button";

/**
 * Common Center Message Dailog Component
 * Supports multiple variants for displaying messages for success, error and info
 */

const ICON_MAP = {
  success: CheckCircleOutlineIcon,
  error: ErrorOutlineIcon,
  info: InfoOutlinedIcon,
};

const CenterMessageDialog = ({
  open = false,
  type = "info", // success | error | info
  title,
  message,
  buttonText = "OK",
  onClose,
}) => {
  const { colors, radius, font } = useDesignTokens();

  const COLOR_MAP = {
    success: colors?.success?.main,
    error: colors?.error?.main,
    info: colors?.info?.main,
  };

  const Icon = ICON_MAP[type] || InfoOutlinedIcon;
  const color = COLOR_MAP[type] || COLOR_MAP.info;

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        // onClose();
        onClose?.(event, reason);
      }}
      maxWidth="xs"
      fullWidth
      sx={{
        zIndex: 2400,
        "& .MuiDialog-paper": {
          borderRadius: radius?.default,
          padding: 2,
        },
      }}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          gap={1.5}
        >
          <Icon sx={{ fontSize: 55, color }} />

          {title && (
            <Typography variant="h6" fontWeight={font?.weight?.fontW600}>
              {title}
            </Typography>
          )}

          {message && (
            <Typography variant="body2" fontSize={font?.size?.fontSz16}>
              {message}
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          variant="primary"
          size="medium"
          // onClick={onClose}
          onClick={() => onClose?.()}
          sx={{ minWidth: 90, textTransform: "none" }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CenterMessageDialog;
